import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Extra Item',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'row',
          marginBottom: px(8),
          justifyContent: 'space-between',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
